import { setAuthPolicyHooks } from '@xstudios/xapp-auth/services/authService'
import { useNotificationState } from '@xstudios/xapp-core/foundation'

const AUTH_NOTIFY_DEDUPE_MS = 3000
let lastAuthNotifyAt = 0
let lastAuthNotifyKey = ''

export function registerGlobalAuthPolicy() {
  setAuthPolicyHooks({
    onRequestError: (context) => {
      maybeNotifyGenericAuthError(context)
    },
  })
}

function buildGenericAuthMessage({ detail, status }) {
  const normalizedDetail = String(detail?.message || detail || '').toLowerCase()
  if (normalizedDetail.includes('missing bearer token')) {
    return 'Authentication required.'
  }
  if (Number(status) === 403) {
    return 'You do not have permission to perform this action.'
  }
  return 'Your session is missing or expired. Please sign in again.'
}

function isGenericAuthError({ code, detail, message, status }) {
  const normalizedCode = String(code || '')
    .trim()
    .toLowerCase()
  const normalizedMessage = String(message || '').toLowerCase()
  const normalizedDetail = String(detail?.message || detail || '').toLowerCase()

  if (Number(status) === 403) return true
  if (Number(status) !== 401) return false
  if (normalizedCode === 'qb_reauth_required') return false
  if (
    normalizedMessage.includes('quickbooks') &&
    normalizedMessage.includes('reconnect')
  ) {
    return false
  }

  return (
    normalizedMessage.includes('missing bearer token') ||
    normalizedDetail.includes('missing bearer token') ||
    normalizedMessage.includes('token') ||
    normalizedDetail.includes('token') ||
    normalizedMessage.includes('unauthorized') ||
    normalizedDetail.includes('unauthorized') ||
    normalizedMessage.includes('not authenticated') ||
    normalizedDetail.includes('not authenticated') ||
    normalizedMessage.includes('credential') ||
    normalizedDetail.includes('credential')
  )
}

function maybeNotifyGenericAuthError({
  code,
  detail,
  isAuthTokenEndpoint,
  message,
  status,
}) {
  if (isAuthTokenEndpoint) return
  if (!isGenericAuthError({ code, detail, message, status })) return

  const notifyMessage = buildGenericAuthMessage({ detail, status })
  const dedupeKey = `${status}|${notifyMessage}`
  const now = Date.now()
  if (
    dedupeKey === lastAuthNotifyKey &&
    now - lastAuthNotifyAt < AUTH_NOTIFY_DEDUPE_MS
  ) {
    return
  }
  lastAuthNotifyKey = dedupeKey
  lastAuthNotifyAt = now

  const { notify } = useNotificationState()
  notify({
    color: 'warning',
    text: notifyMessage,
    title: 'Authentication',
  })
}
